module.exports = __webpack_public_path__ + "assets/idReverification.2a20f426.svg";